import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GenericInsightsElements from "./routes/GenericInsightsElements";

export default store => ({
  path: ":genericInsightType",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "generic-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [GenericInsightsElements(store)],
});
